import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Button,
  makeStyles,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { SkanskaColorTokens } from "../../style/colors";
import { useDeleteChapterImage } from "../../hooks/useImages";
import { Image } from "../../models/Image";
import { Delete20Regular } from "@fluentui/react-icons";
import { ClientRoutes } from "../../models/ClientRoutes";
import { useNavigate } from "react-router-dom";

interface ImageDeleteButtonProps {
  image: Image;
}
const useStyles = makeStyles({
  confirmDeleteButton: {
    backgroundColor: SkanskaColorTokens.color_secondary_white,
    color: SkanskaColorTokens.color_tertiary_red,
    border: `1px solid ${SkanskaColorTokens.color_tertiary_red}`,
    ":hover, :focus, :active": {
      backgroundColor: SkanskaColorTokens.color_tertiary_red_15,
      color: SkanskaColorTokens.color_tertiary_red,
      border: `1px solid ${SkanskaColorTokens.color_tertiary_red}`,
    },
  },
});

export const ImageDeleteButton = (props: ImageDeleteButtonProps) => {
  const navigate = useNavigate();

  const imageId =
    props.image.imageId ||
    props.image.versionId ||
    ("id" in props.image ? props.image.id : "");

  const { mutateAsync: deleteChapterImage, isPending } =
    useDeleteChapterImage(imageId);

  const classes = useStyles();
  const { t } = useTranslation();

  const onConfirm = async () => {
    await deleteChapterImage();
    navigate(ClientRoutes.MediaChapterPage);
  };

  return (
    <Dialog modalType="alert">
      <DialogTrigger disableButtonEnhancement>
        <Button size="large" className={classes.confirmDeleteButton}>
          <Delete20Regular />
          {t("delete")}
        </Button>
      </DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t("delete")}</DialogTitle>
          <DialogContent>
            {t("deleteImagePrompt")} "{props.image.title}
            "?
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">{t("cancel")}</Button>
            </DialogTrigger>
            <DialogTrigger disableButtonEnhancement>
              <Button
                disabled={isPending}
                onClick={onConfirm}
                appearance="primary"
              >
                {t("delete")}
              </Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
